import * as React from 'react';
import { withRouter } from 'common/components/core/router';
import compose from 'recompose/compose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { themr } from 'react-css-themr';

import { showToast } from 'common/redux/actions/toast';
import { ToastTypes } from 'common/components/core/toast/Toast';
import { createExistingPlan } from 'common/middleware/api';
import { dashboardColors } from 'common/enums/ColorEnum';

import { confirmationDialogFactory } from 'common/components/core/dialog/ConfirmationDialog';
import { Button, ButtonTypes } from 'common/components/core/button';

import defaultTheme from 'common/entity/pjpMaster/CreateExistingBeatDialog.scss';

const CustomActions = ({
    onCancel,
    onAccept,
    t,
    acceptActionLabel = t('yesCreate'),
    cancelActionLabel = t('cancel'),
    isLoading,
    theme
}) => {
    return (
        <div className={theme.actions}>
            {onCancel ? (
                <Button
                    key={'cancelAction'}
                    flat
                    semibold
                    uppercase
                    label={cancelActionLabel}
                    theme={theme}
                    buttonType={ButtonTypes.Text}
                    onClick={onCancel}
                />
            ) : null}
            {onAccept ? (
                <Button
                    key={'acceptAction'}
                    flat
                    semibold
                    uppercase
                    color={dashboardColors.darkSkyBlue.name}
                    label={acceptActionLabel}
                    theme={theme}
                    buttonType={ButtonTypes.Text}
                    isLoading={isLoading}
                    onClick={onAccept}
                />
            ) : null}
        </div>
    );
};

const ConfirmationDialog = confirmationDialogFactory({
    Actions: CustomActions
});

class CreateExistingBeatDialog extends React.PureComponent {
    state = {
        isExistingBeatPlanCreationInProgress: false
    };

    onDismiss = () => {
        const { onDismiss } = this.props;
        onDismiss();
    };

    handleCreateExistingBeatPlan = () => {
        const {
            fetchOptions,
            onDismiss,
            reloadData,
            showToast,
            t
        } = this.props;
        const { pjpId, clientId } = fetchOptions;
        const params = { pjpId, clientId };
        this.setState({ isExistingBeatPlanCreationInProgress: true });
        createExistingPlan
            .post(params)
            .then(() => {
                this.setState(
                    { isExistingBeatPlanCreationInProgress: false },
                    () => {
                        const toast = {
                            message: t('addEntitySuccessMessage'),
                            type: ToastTypes.Success
                        };
                        showToast(toast, params);
                        reloadData();
                        onDismiss();
                    }
                );
            })
            .catch(error => {
                const toast = {
                    message: error.message,
                    type: ToastTypes.Error,
                    timeout: 5000
                };
                showToast(toast, params);
                this.setState({ isExistingBeatPlanCreationInProgress: false });
            });
    };
    render() {
        const { t, theme } = this.props;
        const { isExistingBeatPlanCreationInProgress } = this.state;

        return (
            <ConfirmationDialog
                isLoading={isExistingBeatPlanCreationInProgress}
                theme={theme}
                onAccept={this.handleCreateExistingBeatPlan}
                onCancel={this.onDismiss}
                onDismiss={this.onDismiss}
                active
                innerText={t('existingBeatPlanCreationMessage')}
                title={t('createExistingBeatPlan')}
            />
        );
    }
}

const mapDispatchToProps = {
    showToast
};

export default compose(
    withRouter,
    themr('CreateExistingBeatDialog', defaultTheme),
    connect(null, mapDispatchToProps),
    translate('entityManagement')
)(CreateExistingBeatDialog);
